import { FC } from 'react';

import { IconProps } from './types';

export const SearchIcon: FC<IconProps> = ({
	color = 'currentColor',
	height = 24,
	size,
	width = 25,
	className,
}) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		viewBox="0 0 25 24"
		className={className}
		width={size ?? width}
		height={size ?? height}
	>
		<path
			fill={color}
			fillRule="evenodd"
			d="M2 11c0 4.96 4.038 9 9 9 2.122 0 4.075-.74 5.615-1.97l3.678 3.68c.195.19.451.29.707.29s.512-.1.707-.29c.391-.39.391-1.03 0-1.42l-3.678-3.67A9 9 0 0 0 20 11c0-4.96-4.037-9-9-9-4.962 0-9 4.04-9 9m14.019 4.87A6.97 6.97 0 0 0 18 11c0-3.86-3.141-7-7-7s-7 3.14-7 7 3.14 7 7 7c1.893 0 3.613-.76 4.874-1.98.022-.03.045-.05.069-.08.024-.02.05-.04.076-.07"
		/>
	</svg>
);
